import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  ActivatedRoute,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  Router,
} from '@angular/router';

import { Subscription } from 'rxjs';

@Component({
  selector: 'app-live-class-layout',
  templateUrl: './live-class-layout.component.html',
  styleUrls: ['./live-class-layout.component.css'],
})
export class LiveClassLayoutComponent implements OnInit, OnDestroy {
  public isShowHeader: boolean = true;
  public routerSubscription: Subscription[] = [];
  public isRecordingClass: boolean = false;

  constructor(
    private router: Router,
    private _activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.isRecordingClass =
      this._activatedRoute?.snapshot?.data?.isRecordingClass;

    this.checkCurrentRoute();
    this.routerSubscription.push(
      this.router.events.subscribe((event) => {
        if (
          event instanceof NavigationCancel ||
          event instanceof NavigationError ||
          event instanceof NavigationEnd
        ) {
          console.log('Router Subscription: ', event.url, this.router.url);
          this.checkCurrentRoute();
        }
      })
    );
    this._activatedRoute.data.subscribe((_routerData: any) => {
      this.checkLiveClassCSS(_routerData);
    });
  }

  checkLiveClassCSS = (_routerData: any = null) => {
    let head = document.getElementsByTagName('head');
    let cd = head[0].querySelectorAll('link.live-styles');
    if (cd && cd?.length > 0) {
      for (let i = 0; i < cd.length; i++) {
        head[0].removeChild(cd[i]);
      }
    }
    if (_routerData?.isLiveClass != undefined && _routerData?.isLiveClass) {
      let linkNode1 = document.createElement('link');
      linkNode1.setAttribute('rel', 'stylesheet');
      linkNode1.setAttribute('href', '/assets/css/live-portal-styles.css');
      linkNode1.className = 'live-styles';
      let linkNode2 = document.createElement('link');
      linkNode2.setAttribute('rel', 'stylesheet');
      linkNode2.setAttribute('href', '/assets/css/live-class-style.css');
      linkNode2.className = 'live-styles';
      let linkNode3 = document.createElement('link');
      linkNode3.setAttribute('rel', 'stylesheet');
      linkNode3.setAttribute('href', '/assets/css/responsive.css');
      linkNode3.className = 'live-styles';
      head[0].appendChild(linkNode1);
      head[0].appendChild(linkNode2);
      head[0].appendChild(linkNode3);
    }
  };

  checkCurrentRoute = () => {
    if (this.router.url.includes('joining-class')) {
      this.isShowHeader = false;
    } else {
      this.isShowHeader = true;
    }
  };

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.forEach((v) => v.unsubscribe());
    }
  }
}
